const SvgCloud1 = (props) => (
  <>
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M96 0 16 48v96M16 144l73.15 43.89M102.85 187.89 176 144M96 0l80 48v96M96 0v88M96 288v-.06M96 296v87.94M102.85 283.89 176 240M102.85 100.11 176 144M89.15 100.11 16 144M176 240v-96M16 144v96M89.15 283.89 16 240M102.85 196.11 176 240M16 240l73.15-43.89M176 240v96l-80 48-80-48v-96M102.85 187.89c-1.4-2.33-3.94-3.89-6.85-3.89s-5.45 1.56-6.85 3.89M89.15 187.89c-.72 1.2-1.15 2.61-1.15 4.11s.42 2.91 1.15 4.11M102.85 196.11c-1.4 2.33-3.94 3.89-6.85 3.89s-5.45-1.56-6.85-3.89M102.85 196.11c.72-1.2 1.15-2.61 1.15-4.11s-.42-2.91-1.15-4.11M102.85 100.11c.72-1.2 1.15-2.61 1.15-4.11 0-4.42-3.58-8-8-8M102.85 100.11c-1.4 2.33-3.94 3.89-6.85 3.89s-5.45-1.56-6.85-3.89M96 88c-4.42 0-8 3.58-8 8 0 1.51.42 2.91 1.15 4.11"
    />
    <path
      d="M89.15 283.89A7.985 7.985 0 0 0 88 288c0 4.42 3.58 8 8 8M96 296c4.42 0 8-3.58 8-8 0-1.51-.42-2.91-1.15-4.11M89.15 283.89c1.4-2.33 3.94-3.89 6.85-3.89s5.45 1.56 6.85 3.89"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgCloud1;
